import React from 'react';
import PropTypes, {InferProps} from 'prop-types';
import {OnbordingRelatedPeopleContext} from 'context';
import {
    ConsigneeCatalog,
    ConsigneeTerms,
    RealOwnerInfo,
    RepresentativeInfo,
    ShareholderInfo,
} from 'commons/types/Types';

EfeRelatedPeopleProvider.propTypes = {
    children: PropTypes.node.isRequired,
};

function EfeRelatedPeopleProvider(props: InferProps<typeof EfeRelatedPeopleProvider.propTypes>) {
    const {children} = props;
    const [percentageCompleted, setPercentageCompleted] = React.useState<number>(0);
    const [shareholders, setShareholders] = React.useState<ShareholderInfo[]>([]);
    const [representatives, setRepresentatives] = React.useState<Array<RepresentativeInfo>>([]);
    const [selectedRepresentative, setSelectedRepresentative] = React.useState<number>(-1);
    const [tempRepresentative, setTempRepresentative] = React.useState<
        RepresentativeInfo | undefined
    >();
    const [consigneesConfig, setConsigneesConfig] = React.useState<ConsigneeTerms>();
    const [loadUsers, setLoadUsers] = React.useState<Array<ConsigneeCatalog>>([]);
    const [tempShareholder, setTempShareholder] = React.useState<ShareholderInfo | undefined>();
    const [isTempShareholderActive, setTempShaholderActive] = React.useState<boolean>(false);
    const [shareholdersSizeTemp, setShareholdersSizeTemp] = React.useState<number>(1);
    const [realOwners, setRealOwners] = React.useState<Array<RealOwnerInfo>>([]);
    const [tempRealOwner, setTempRealOwner] = React.useState<RealOwnerInfo | undefined>();
    const [isTempRealOwnerActive, setTempRealOwnerActive] = React.useState<boolean>(false);
    const [editLocation, setEditLocation] = React.useState<boolean>(false);
    const [shareholderPersonType, setShareholderPersonType] = React.useState<string>('');

    function resetRelatedPeopleContext() {
        setPercentageCompleted(0);
        setRealOwners([]);
        setShareholders([]);
        setRepresentatives([]);
        setTempRealOwner(undefined);
        setTempRepresentative(undefined);
        setTempShareholder(undefined);
        setTempRealOwnerActive(false);
        setTempShaholderActive(false);
        setShareholdersSizeTemp(1);
        setConsigneesConfig(undefined);
    }

    return (
        <OnbordingRelatedPeopleContext.Provider
            value={{
                percentageCompleted,
                setPercentageCompleted,
                shareholders,
                setShareholders,
                representatives,
                setRepresentatives,
                setSelectedRepresentative,
                selectedRepresentative,
                tempRepresentative,
                setTempRepresentative,
                tempShareholder,
                setTempShareholder,
                isTempShareholderActive,
                setTempShaholderActive,
                shareholdersSizeTemp,
                setShareholdersSizeTemp,
                realOwners,
                setRealOwners,
                tempRealOwner,
                setTempRealOwner,
                isTempRealOwnerActive,
                setTempRealOwnerActive,
                editLocation,
                setEditLocation,
                shareholderPersonType,
                setShareholderPersonType,
                resetRelatedPeopleContext,
                consigneesConfig,
                setConsigneesConfig,
                loadUsers,
                setLoadUsers,
            }}>
            {children}
        </OnbordingRelatedPeopleContext.Provider>
    );
}

export default EfeRelatedPeopleProvider;
